import { DataTableColumn } from '../../../../../../../../common/_custom/DataTable/DataTable.types';
import { DEAL_COLUMNS_BYPASSING_ROW_DISABLE } from '../../../../../../../../store/investor/constants';

// Shared by the table headers and the drawer columns so both keep these cells interactive on disabled rows.
export function applyRowDisableBypass(columns: DataTableColumn[] | undefined | null): DataTableColumn[] {
    return (columns ?? []).map((column) =>
        DEAL_COLUMNS_BYPASSING_ROW_DISABLE.includes(column.field) ? { ...column, bypassRowDisable: true } : column,
    );
}
